/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod/v4";

export const potentialScheduleResponseDtoSchema = z.object({
    "appointmentType": z.string().nullish(),
"suggestedDate": z.string().nullish(),
"suggestedDateText": z.string().nullish(),
"suggestedTime": z.string().nullish(),
"locationOrAddress": z.string().nullish(),
"status": z.enum(["proposed", "confirmed", "rejected"]).nullish(),
"confidence": z.optional(z.number()),
"sourceSignalId": z.optional(z.string()),
"lastSeenAt": z.optional(z.string())
    })